
class ValidationDomainHelp {

    constructor(email, name, domain) {
        this.email = email;
        this.name = name;
        this.domain = domain;
    }

    sendValidationDomainHelp(callback) {
        $.ajax({
            url: euPortalConfig.euapi_base_uri+'help/domain_validation',
            type: 'POST',
            data: JSON.stringify({
                email: this.email,
                domain: this.domain
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            statusCode: {
                422: function() {
                    callback(false);
                },
                400: function() {
                    callback(false);
                },
                200: function() {
                    callback(true);
                }
            }
        });
    }
}

export default ValidationDomainHelp;
